module.exports = __webpack_public_path__ + "img/brightpoint_1.f47a267a.png";